module.exports = __webpack_public_path__ + "img/illustration-404.974297c6.svg";